import { useEffect, useRef } from "react";

const CALENDLY_SCRIPT = "https://assets.calendly.com/assets/external/widget.js";

export const CalendlyInline = ({ url, className = "" }) => {
  const widgetRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const initialise = () => {
      if (cancelled || !widgetRef.current || !window.Calendly) return;
      widgetRef.current.replaceChildren();
      window.Calendly.initInlineWidget({
        url,
        parentElement: widgetRef.current,
      });
    };

    const existingScript = document.querySelector(`script[src="${CALENDLY_SCRIPT}"]`);

    if (window.Calendly) {
      initialise();
    } else if (existingScript) {
      existingScript.addEventListener("load", initialise, { once: true });
    } else {
      const script = document.createElement("script");
      script.src = CALENDLY_SCRIPT;
      script.async = true;
      script.addEventListener("load", initialise, { once: true });
      document.body.appendChild(script);
    }

    return () => {
      cancelled = true;
      existingScript?.removeEventListener("load", initialise);
    };
  }, [url]);

  return (
    <div
      ref={widgetRef}
      className={`calendly-inline-widget ${className}`}
      data-testid="calendly-widget"
      data-url={url}
      style={{ minWidth: "320px", height: "700px" }}
    />
  );
};
